let customSelectors = {
    "sidebarBtn": window.themeVariables.settings.showSidebar ? document.getElementById('toggle-vertical-sidebar'): {},
    "sidebar": document.querySelector('.vertical-menu'),
    "sidebarAccordionTitle": window.themeVariables.settings.showSidebar ? document.querySelector('.vertical-menu').querySelectorAll('.sidebar-accordion-title') : {},
    "sidebarAccordionContent": window.themeVariables.settings.showSidebar ? document.querySelector('.vertical-menu').querySelectorAll('.sidebar-accordion-content'): {}
},
customFunctions = {
    'addEventToSidebarBtn' : () => customSelectors.sidebarBtn.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector('.main-content-inner ').classList.toggle('active');
    }),
    'addAccordionToSidebar': () => {
        customSelectors.sidebar.addEventListener('click', (e)=>{
            let ele = e.target.parentElement;
            if(ele.classList.contains('sidebar-accordion-title')){
                e.preventDefault();
                let index = ele.dataset.index;
                customFunctions.closeAllSidebarMenus(index);
                customSelectors.sidebar.querySelector(`p[data-index="${index}"]`).classList.toggle('active');
                customSelectors.sidebar.querySelector(`ul[data-index="${index}"]`).classList.toggle('hide');
            }
        })
    },
    'closeAllSidebarMenus': position => {
        customSelectors.sidebarAccordionContent.forEach((ele, index) => {
            let accordionTitle = customSelectors.sidebar.querySelectorAll('[data-index]')[index];
            if(ele.dataset.index != position) ele.classList.add('hide');
            if(accordionTitle.dataset.index != position) accordionTitle.classList.remove('active');
        })
    },
    'init': () => {
        window.themeVariables.settings.showSidebar && (customFunctions.addEventToSidebarBtn(), customFunctions.addAccordionToSidebar());
    },
};

(() => customFunctions.init())();

var sourceElement = document.querySelector(".technial_table");

var clone1 = sourceElement.cloneNode(true);
var clone2 = sourceElement.cloneNode(true);

var target1 = document.querySelector(".techtablkem");
target1.appendChild(clone1);

var target = document.querySelector(".techtablke");
target.appendChild(clone2);

var sourceElementtd = document.querySelectorAll(".technial_table td");
console.log(sourceElementtd);
var sourceElementlenght = sourceElementtd.length;
console.log(sourceElementlenght);

if(sourceElementlenght === 0)
{
target1.style.display = "none";
target.style.display = "none";  
} 

$('body').on('mouseover','.swatch-view-item',function(){
    let id = $(this).attr('orig-value');
    let imgStyle = $(this).find('.star-set-image').attr('style');
    let imgSrc = imgStyle.split("//");
    imgSrc = imgSrc[1].replace(");").split("?")[0];
    // console.log(imgStyle, 'imgSrc');
    if(imgSrc){
      $('.product-gallery__media-list .product-gallery__media.is-selected img').attr('srcset', '//'+imgSrc);
    }
    let parentEle = $(this).parents('fieldset');
    $(parentEle).find('.swatch-variant-name').text(` - ${id}`);
}).on('mouseout','.swatch-view-item',function(){
    let parentEle = $(this).parents('fieldset');
    let selectedVariant = $('.swatch-view-item[aria-checked="true"]').attr('orig-value');
    $(parentEle).find('.swatch-variant-name').text(` - ${selectedVariant}`);

    let imgStyle = $('.swatch-view-item[aria-checked="true"]').find('.star-set-image').attr('style');
    let imgSrc = imgStyle.split("//");
    imgSrc = imgSrc[1].replace(");").split("?")[0];
    // console.log(imgStyle, 'imgSrc', 'else');
    if(imgSrc){
      $('.product-gallery__media-list .product-gallery__media.is-selected img').attr('srcset', '//'+imgSrc);
    }
})